import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useControlReducer = () => useSelector((state: ApplicationState) => state.control);
